module.exports = __webpack_public_path__ + "static/media/sanderklos.ae7e1e5b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/sanderklos.webp
// module id = 575
// module chunks = 0